import { render, staticRenderFns } from "./AddContentToLibrariesModal.vue?vue&type=template&id=ba12efa6&lang=pug&"
import script from "./AddContentToLibrariesModal.vue?vue&type=script&lang=js&"
export * from "./AddContentToLibrariesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports